const ArrowRight = () => {
    return (
        <svg
            width='15'
            height='10'
            viewBox='0 0 15 10'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M14 5L1 5M14 5L10 9M14 5L10 1'
                stroke='white'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default ArrowRight;
